import React,{ useState,useEffect, useMemo } from 'react';
import axios from "axios";
import store from '../store';
import Check from './Check';
import {  Redirect } from 'react-router-dom';

const CartApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/Cart/`
})
const DeleteCartItemApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/Cart/del/`
})
const GigsApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/GigsApi/`
})
const OrderCreateApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/OrdersAPI/`
})

const Cart = () => {
    useEffect(() => {
        getCartItems();
      },[]);
    const[cart,setCart]=useState([]);
    const[mobile,setMobile]=useState(null);
    const[address,setAddress]=useState(null);
    const[orderCompleted,setOrderCompleted]=useState(false);
    const[paymentMethod,setPaymentMethod]=useState('not selected');
    
    const deleteCartItem = async (cartItemID) => {
        await DeleteCartItemApi.delete(`/${cartItemID}/`).then(({data})=>data);
        getCartItems()
    }
    
    const getCartItems = async () => {
        let data = await CartApi.get(`/${store.getState().auth.user.id}/`).then(({data})=>data);
        setCart(data);
    }
    const quantitySet = (action, cartItemID) => {
        setCart((preCart) => {
            return preCart.map((cartItem) => {
                if(cartItem.id === cartItemID) {
                    if(action === "inc"){
                        if(cartItem.quantity < 5){
                            cartItem.quantity += 1
                        }
                    }else{
                        if(cartItem.quantity > 1){
                            cartItem.quantity -= 1
                        }
                    }
                }
                return cartItem
            })
        })
    }
    
    const onchange = (data) => {
        setPaymentMethod(data);
    }

    const calculateOrderItemsPrice = () => {
        let price = 0.0
        for(let itemIndex in cart){
            price += (cart[itemIndex].item.price * cart[itemIndex].quantity)
        }
        return price
    }

    const orderItemsPrice = useMemo(() => calculateOrderItemsPrice(), [cart])

    const preparePayload = () => {
        // Prepare order items
        let order_items = []
        for(let itemIndex in cart){
            let order_item = {
                seller: cart[itemIndex].item.seller,
                item: cart[itemIndex].item.id,
                price: cart[itemIndex].item.price * cart[itemIndex].quantity,
                quantity: cart[itemIndex].quantity
            }
            order_items.push(order_item)
        }

        let data = {
            buyer: store.getState().auth.user.id,
            payment_method: paymentMethod,
            address: address,
            mobile: mobile,
            price: orderItemsPrice+70.0,
            order_items: order_items
        }
        return data
    }

    const addOrder =async () => {
        let data = preparePayload()

        try {
            console.log("data: ", data)
            let res = await OrderCreateApi.post('/',data);
            if(res?.status !== 201){
                alert("Can't place order!")
            }else{
                alert("Order Placed Successfully!");
                setOrderCompleted(true)
            }
        }
        catch{
            alert("Can't place order!");
        }
    }
    
    
    return (
        <><br/><br/>
            { orderCompleted && <Redirect to="/" />}
            <div className='container mt-5'>
            <div className='row pt-3 pb-3'>
                <div className='col col-lg-8 w3-light-gray'>
                    <table className="table table-borderless">
                    <thead className='w3-gray'>
                        <tr>
                        <th scope="col" style={{width:'5%'}}> </th>
                        <th scope="col" style={{width:'50%'}}>Item</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Price</th>
                        </tr>
                    </thead>
                    <tbody>
                    {cart.map((cartItem) => {
                    return(
                        <tr key={cartItem.id}>
                        <td><div class="mt-5">
                            <button  className='cross-btn' type="button" onClick={() => deleteCartItem(cartItem.id)}> </button>
                            </div></td>
                        <td><br/>
                            <img src={cartItem.item.images} style={{height:'70px', width:'70px'}} alt="..." />
                            
                            <p style={{textAlign:'justify', fontSize:'13px', width:'250px'}} className='me-5 mt-3'>{cartItem.item.title}</p>
                        </td>
                        <td>
                        <div className="btn-group mt-5 pt-4" role="group" >
                            <button type="button" className="btn btn-secondary btn-primary" onClick={()=>quantitySet('dec', cartItem.id)}>-</button>
                            <button type="button" className="btn btn-secondary btn-primary" >{cartItem.quantity}</button>
                            <button type="button" className="btn btn-secondary btn-primary" onClick={()=>quantitySet('inc', cartItem.id)} >+</button>
                        </div>
                        </td>
                        <td>
                            <h3 className='pt-4 mt-5' style={{color:'black'}}>Rs.{cartItem.item.price*1}</h3>
                        </td>
                        </tr>
                    
                    
                    );
                    })}
                    </tbody>
                    </table><br/>
                    </div>
               

                    <div className='col w3-light-gray ms-2' style={{height:'370px'}}>
                        <h5><b>Shipping & Billing</b></h5><hr/>
                        <div className="input-group input-group-sm mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-primary" style={{width:'50px', paddingLeft: '15px'}} ><i className='fas fa-phone-alt'/></span>
                        </div>
                        <input type="text" className="form-control" placeholder="Enter your Mobile No." onChange={(e)=>setMobile(e.target.value)} />
                        </div>

                        <div className="input-group input-group-sm mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-primary" style={{width:'50px', paddingLeft: '18px'}} ><i className='fas fa-map-marker-alt'/></span>
                        </div>
                        <textarea type="text" className="form-control" placeholder="Enter Address eg. House# 123, Street# 123, ABC Road" onChange={(e)=>setAddress(e.target.value)}  />
                        </div>

                        <h5>Order Summary</h5>
                        <div className='row'>
                            <div className='col'>
                            <p style={{fontSize:'12px', color:'gray'}}>Sub Total <br/>Shipping Fee</p>
                            </div>
                            <div className='col me-5' style={{textAlign:'end'}}>
                            <p style={{fontSize:'12px', color:'gray'}}>Rs. {orderItemsPrice}<br/>Rs. {orderItemsPrice !== 0.0?  70: 0}</p>
                            </div>
                        </div>
                        <div className='row' >
                            <div className='col'>
                                <span style={{color:'black', fontSize:'19px'}}>Total</span>
                            </div>
                            <div className='col me-5' style={{textAlign:'end'}}>
                                <span style={{color:'black', fontSize:'19px'}}> Rs. {orderItemsPrice !== 0.0 ? orderItemsPrice+70.0 : null}</span>
                            </div>
                        </div><br/>
                        {cart.length !== 0 ?
                        <button type="button" className="btn btn-primary" style={{width:'300px', marginLeft: '50px'}} data-bs-toggle="modal" data-bs-target="#payment" onClick={()=>setPaymentMethod('not selected')}><i className="fa fa-credit-card" /> Checkout Now</button>
                        :
                        <button type="button" className="btn btn-primary" style={{width:'300px', marginLeft: '50px'}} onClick={()=>alert('Select a product to checkout!')}><i className="fa fa-credit-card" /> Checkout Now</button>
                        }
                    </div>
            </div>
            </div>


            {/* modal */}
            <div className="modal fade" id="payment" tabIndex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Order Confirmation</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>


                <div className="modal-body">
                {(paymentMethod === 'not selected') ?
                    <>
                    <b>Select a payment Method</b><br/><br/>
                    <button type="button" className="btn btn-primary ms-5" onClick={()=>setPaymentMethod('cod')} ><i className='fa fa-money'/> Cash on Delivery  </button>
                    <button type="button" className="btn btn-primary ms-5" onClick={()=>setPaymentMethod('online')} ><i className='fa fa-credit-card'/> Online Payment </button>
                    <br/><br/>
                    </>
                    :(paymentMethod === 'cod') || (paymentMethod === 'stripe') ?
                        <>
                        <div className='row'>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                Buyer Name <br/>Mobile No. <br/>Address 
                                </p>
                            </div>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    {store.getState().auth.user.first_name + ' ' + store.getState().auth.user.last_name}<br/>{mobile}<br/>{address}
                                </p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    Item Quantity<br/>Total Bill<br/>Payment Method
                                </p>
                            </div>
                            <div className='col'>
                                <p style={{color:'gray'}}>
                                    1<br/>{orderItemsPrice+70.0}<br/>Cash On Delivery
                                </p>
                            </div>
                        </div>
                        </>
                    :
                    <Check data={paymentMethod} price={orderItemsPrice+70.0} onchange={(e) => { onchange(e) }}/>
                } 
                </div>

                
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    {paymentMethod === 'cod' || paymentMethod === 'stripe' ? <button type="reset" className="btn btn-primary btn-primary"  data-bs-dismiss="modal" onClick={addOrder} >Confirm Order</button> : null}
                </div>
                </div>
            </div>
            </div>
        </>
    );
};



export default Cart;
